import Organisationseinheit from './Organisationseinheit'

export default (base) => {
  return {
    String (field) {
      return {
        label: `${base}.form.${field}`,
        field,
        type: 'string'
      }
    },

    Text (field, maxlength = 2000) {
      return {
        label: `${base}.form.${field}`,
        field,
        maxlength,
        type: 'text'
      }
    },

    Number (field) {
      return {
        label: `${base}.form.${field}`,
        field,
        type: Number
      }
    },

    Boolean (field) {
      return {
        label: `${base}.form.${field}`,
        field,
        type: Boolean
      }
    },

    Date (field) {
      return {
        label: `${base}.form.${field}`,
        field,
        type: Date
      }
    },

    UneditableDate (field) {
      return {
        label: `${base}.form.${field}`,
        field,
        type: Date,
        editable: false
      }
    },

    URL (field, text) {
      return {
        label: `${base}.form.${field}`,
        field,
        type: 'link',
        icon: 'link',
        computed (data) {
          if (data && data[field]) {
            return {
              href: data[field],
              text: text || data[field]
            }
          }
          return null
        }
      }
    },

    PrefetchedSingleReference (field, entity, icon, groupBy = null, plain = false) {
      return {
        label: `${base}.form.${field}`,
        type: 'prefetchedObject',
        field,
        entity,
        icon,
        groupBy,
        plain
      }
    },

    SingleReference (field, icon, schema, allowCreate = true, plain = false) {
      return {
        label: `${base}.form.${field}`,
        field,
        render: 'stringRep',
        type: 'object',
        schema,
        icon,
        cardinality: 'single',
        finder: {
          name: 'bySearchRepLike',
          multiValue: false,
          minLength: 0
        },
        allowCreate,
        plain
      }
    },

    SimpleMultiReference (field, icon, schema, allowCreate = true, plain = false) {
      return {
        label: `${base}.form.${field}`,
        field,
        render: 'stringRep',
        type: 'object',
        schema,
        icon,
        cardinality: 'many',
        finder: {
          name: 'bySearchRepLike',
          multiValue: false,
          minLength: 0
        },
        allowCreate,
        plain
      }
    },

    UneditableSimpleMultiReference (field, icon, schema, allowCreate = true, plain = false) {
      return {
        label: `${base}.form.${field}`,
        field,
        render: 'stringRep',
        type: 'object',
        schema,
        icon,
        cardinality: 'many',
        finder: {
          name: 'bySearchRepLike',
          multiValue: false,
          minLength: 0
        },
        allowCreate,
        editable: false,
        plain
      }
    },

    Label (name) {
      return {
        label: `${base}.form.${name}`,
        type: 'label'
      }
    },

    MultiReference (field, icon, schema, allowCreate = true, plain = false) {
      return {
        label: `${base}.form.${field}`,
        field,
        render: 'stringRep',
        type: 'object',
        schema,
        icon,
        cardinality: 'many',
        finder: {
          name: 'byMultiValueSearchRep',
          multiValue: true,
          minLength: 4
        },
        allowCreate,
        plain
      }
    },

    SingleReferenceByMultiValueSearchRep (field, icon, schema, allowCreate = true, plain = false) {
      return {
        label: `${base}.form.${field}`,
        field,
        render: 'stringRep',
        type: 'object',
        schema,
        icon,
        cardinality: 'single',
        finder: {
          name: 'byMultiValueSearchRep',
          multiValue: true,
          minLength: 4
        },
        allowCreate,
        plain
      }
    },

    organisationseinheit: {
      label: `${base}.form.organisationseinheit`,
      field: 'organisationseinheit',
      type: 'object',
      icon: 'sitemap',
      cardinality: 'single',
      render: 'stringRep',
      schema: Organisationseinheit,
      finder: {
        name: 'bySearchRepLike',
        multiValue: false,
        minLength: 0
      }
    },

    relevantFuerWeitere: {
      label: `${base}.form.relevantFuerWeitere`,
      field: 'relevantFuerWeitere',
      type: Boolean
    },

    weitereOrganisationseinheiten: {
      label: `${base}.form.weitereOrganisationseinheiten`,
      singularLabel: 'Organisationseinheit',
      field: 'weitereOrganisationseinheiten',
      type: 'object',
      render: 'stringRep',
      icon: 'sitemap',
      cardinality: 'many',
      method: 'bySearchRepLike',
      schema: Organisationseinheit,
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 3,
        opts: {
          sort: [
            'inPubfob,desc',
            'name,asc'
          ]
        }
      },
      allowCreate: false,
      view (data, user) {
        return data.relevantFuerWeitere
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/schema/FieldsGeneric.js